import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { sharedProps } from "~/constants";
import { useIsMobile } from "~/hooks/useIsMobile";
import { DesktopHeader } from "./DesktopHeader";
import { MobileHeader } from "./MobileHeader";

const HEADER_STANDARD_HEIGHT = "4.875rem";
const MOBILE_HEADER_STANDARD_HEIGHT = "4rem";

export const Header: FC = () => {
  const isMobile = useIsMobile();

  const height = isMobile
    ? MOBILE_HEADER_STANDARD_HEIGHT
    : HEADER_STANDARD_HEIGHT;

  return (
    <Flex
      alignItems="center"
      as="header"
      bg="white"
      boxShadow="0 2px 10px 0 rgb(0 0 0 / 5%)"
      h={height}
      justify="center"
      position="sticky"
      top="0"
      w="100%"
      zIndex={3}
    >
      <Flex
        align="center"
        as="nav"
        justify="space-between"
        wrap="wrap"
        {...sharedProps.max.content}
        px={4}
      >
        {isMobile ? <MobileHeader /> : <DesktopHeader />}
      </Flex>
    </Flex>
  );
};
